import * as Sentry from '@sentry/nuxt'

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://04fcca41f416bf3d1a0b48b31ec89501@o56838.ingest.us.sentry.io/4507311359524864',
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 0.5,
    integrations: [Sentry.replayIntegration()],
    debug: false,
  })
} else {
  console.log('Sentry disabled in non-production environment')
}
